import { addPDFSign } from "tasks/api";
import { storage } from "common/config/Firebase"

const savePDFSignUseCase = async (id, url, type, sign) => {

    if (type === 1) {
        const refSign = storage.ref().child(`${id}-1-sign.png`)
        await refSign.putString(sign, "data_url")
    } else if (type === 2) {
        const refSign = storage.ref().child(`${id}-2-sign.png`)
        await refSign.putString(sign, "data_url")
    }

    return addPDFSign(id, url)
}

export default savePDFSignUseCase;